import { useEffect, useState } from "react";
import generateShareImage from "../../ShareImageCard/generateShareImage";
const useShareImage = (config) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [imageBlob, setImageBlob] = useState(null);
    const [imageError, setImageError] = useState(false);
    const { shareItem, shareUrl, showQrCode, showLinkPlaceholder, inlineCampaign, isPost, } = config;
    const { imageUrl, campaignTitle, caption, } = shareItem;
    const resolvedInlineCampaign = inlineCampaign !== null && inlineCampaign !== void 0 ? inlineCampaign : shareItem.type !== "update";
    useEffect(() => {
        let cancelled = false;
        setImageError(false);
        setImageBlob(null);
        setImageSrc(null);
        const item = {
            shareItem,
            shareUrl,
            showQrCode,
            showLinkPlaceholder,
            inlineCampaign: resolvedInlineCampaign,
            isPost,
        };
        generateShareImage(item)
            .then((blob) => {
            if (cancelled) {
                return;
            }
            if (!blob) {
                setImageError(true);
                return;
            }
            setImageBlob(blob);
            setImageSrc(URL.createObjectURL(blob));
        })
            .catch(() => {
            if (!cancelled) {
                setImageError(true);
            }
        });
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imageUrl, campaignTitle, caption, showQrCode, showLinkPlaceholder, resolvedInlineCampaign, isPost, shareUrl]);
    useEffect(() => {
        if (!imageSrc) {
            return undefined;
        }
        return () => URL.revokeObjectURL(imageSrc);
    }, [imageSrc]);
    const downloadImage = () => {
        if (!imageSrc) {
            return;
        }
        const link = document.createElement("a");
        link.href = imageSrc;
        link.download = "chuffed-share-image.png";
        link.click();
    };
    return {
        imageSrc, imageBlob, imageError, downloadImage,
    };
};
export default useShareImage;
